/**
 * returns styles to truncate text where it would overflow and show an ellipsis
 */
export const truncateText = (): string => {
  return `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
